# This gets automatically populated bij gulp

exports.date = 1493209979
exports.branch = "master"
exports.hash = "812dda3"
exports.build = 2713
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee